import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';

export const ImprimirEJCGR = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [report, setReport] = useState('');
    const [fecha, setFecha] = useState('');
    const [hasta, setHasta] = useState('');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCredito = useRef();
    const txtEjecucion = useRef();
    const txtFecha = useRef();
    const txtHasta = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtFecha.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Fecha!', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        }

        else if (sigue) {
            imprimirGeneral(fecha)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'fecha') {
            setFecha(e.target.value);
            setActivo(false);
        }
    };

    const onCheck = () => {

        if (txtCredito.current.checked) {
            setReport('Pres_IngrEdoEjecCredi');
            setActivo(false);
        } else if (txtEjecucion.current.checked) {
            if (espiritu === 0) {
                setReport('Pres_IngrEdoEjecOrd1');
            } else {
                setReport('Pres_IngrEdoEjecOrd');
            }
            setActivo(false);
        }

    }

    const imprimirGeneral = (fecha) => {
        
        let fech = moment.utc(fecha).format('DD-MM-YYYY');
        let fechaval = "";
        var reporte = "";
        let condi;
        let val = 0;
        if (props.condicion === 'EJ_DPP01') {
            reporte = 'Pres_CAT_EjecucionGtosMes_Estatal';
            fechaval = "al Día" + " " + "'" + fech + "'";
        } else if (props.condicion === 'EJ_DPP02') {
            reporte = 'Pres_PAR_MovSECTOR';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
        } else if (props.condicion === 'EJ_DPP03') {
            reporte = 'Pres_SCT_MovPROGR';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
        } else if (props.condicion === 'EJ_DPP04') {
            reporte = 'Pres_PAR_MovPROGR';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
        } else if (props.condicion === 'EJ_DPP05') {
            reporte = 'Pres_PAR_MovPROGR2';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
        } else if (props.condicion === 'EJ_DPP06') {
            reporte = 'Pres_CAT_MovGtos_Estatal';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
            val = 1;
        } else if (props.condicion === 'CGR_01') {
            reporte = 'Pres_PAR_CGR01';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
            val = 2;
        } else if (props.condicion === 'CGR_02') {
            reporte = 'Pres_PAR_CGR02';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
            val = 2;
        }

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + fech + "&sql3=" + fechaval + "&sql4=" + condi + "&val=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtFecha.current.value = '';
        setActivo(true);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lx"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtFecha.current.value = fech;
                setFecha(fech);
                if (fech !== '') {
                    setActivo(false);
                } else {
                    setActivo(true);
                }
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir'+' '+props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-6 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Al Día:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtFecha} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="fecha" />
                                        </div>
                                    </div>

                                </div>

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}